import { Link } from "react-router-dom";
import { Logo } from "@/components/Brand";
import { useAuth } from "@/context/AuthContext";

export const PublicLegal = ({ children }) => {
  const { user } = useAuth();
  return (
    <div className="min-h-screen bg-papel px-4 py-6 sm:px-8 lg:px-16" data-testid="public-legal">
      <div className="max-w-4xl mx-auto">
        <div className="flex items-center justify-between gap-4 mb-6">
          <Logo size={52} testId="public-legal-logo" />
          <Link to={user ? "/escribir" : "/entrar"} className="btn-text" data-testid="public-legal-back">{user ? "Volver a tu diario" : "Volver a entrar"}</Link>
        </div>
        {children}
      </div>
    </div>
  );
};
